import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiResponse } from './api.service';

export interface DeletedRecordMeta {
  label: string;
  value: string;
}

export interface DeletedRecord {
  id: string;
  title: string;
  subtitle?: string;
  deletedDate?: string;
  meta: DeletedRecordMeta[];
}

export interface DeletedRecordsPage {
  items: DeletedRecord[];
  total: number;
  page: number;
  pageSize: number;
}

export interface GetDeletedParams {
  search?: string;
  page?: number;
  pageSize?: number;
  eventId?: string;
}

/**
 * SuperAdmin-only recycle bin. `entityKey` matches the backend IRecycleBinHandler.Key
 * (e.g. 'members', 'payments', 'event-members'). Tenant + selected-BU scoping is applied
 * server-side from the JWT/tenant context; event sub-data passes an explicit eventId.
 */
@Injectable({ providedIn: 'root' })
export class RecycleBinService {
  private api = inject(ApiService);

  getDeleted(entityKey: string, params: GetDeletedParams = {}): Observable<ApiResponse<DeletedRecordsPage>> {
    return this.api.get<DeletedRecordsPage>(`recycle-bin/${entityKey}`, params);
  }

  restore(entityKey: string, id: string, eventId?: string): Observable<ApiResponse<unknown>> {
    const query = eventId != null ? `?eventId=${eventId}` : '';
    return this.api.post<unknown>(`recycle-bin/${entityKey}/${id}/restore${query}`, {});
  }
}
